function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { KeyHandler } from '@deephaven/grid';
import { ContextActionUtils } from '@deephaven/components';
class CopyCellKeyHandler extends KeyHandler {
  constructor(irisGrid) {
    super();
    _defineProperty(this, "irisGrid", void 0);
    this.irisGrid = irisGrid;
    this.cursor = null;
  }
  onDown(event, grid) {
    if (event.altKey && !ContextActionUtils.isModifierKeyDown(event) && !event.shiftKey) {
      var _grid$state = grid.state,
        mouseX = _grid$state.mouseX,
        mouseY = _grid$state.mouseY;
      if (mouseX == null || mouseY == null) {
        return false;
      }
      var gridPoint = grid.getGridPointFromXY(mouseX, mouseY);
      if (gridPoint.column != null && gridPoint.row != null) {
        this.cursor = this.irisGrid.props.copyCursor;
        return true;
      }
    }
    return false;
  }
  onUp(event, grid) {
    if (this.cursor === this.irisGrid.props.copyCursor) {
      this.cursor = null;
      return true;
    }
    return false;
  }
}
export default CopyCellKeyHandler;
//# sourceMappingURL=CopyCellKeyHandler.js.map